module.exports = __webpack_public_path__ + "img/img-bottom-pattern.713d34ff.png";